import React from 'react';

export const NoFilterResults: React.FC = () => <h1>No Results!</h1>;
